import { Outlet } from 'react-router-dom';
import { AutoFormModal } from '../../components/auto-form-modal/AutoForm';
import { DataTableModal } from '../../components/data-table-modal/DataTableModal';
import { ConfirmBox } from '../../components/message-boxes/ConfirmBox';
import { CountDownBox } from '../../components/message-boxes/CountDownbox';
import { ErrorMessage } from '../../components/message-boxes/ErrorMessage';
import { PdfViewer } from '../../components/pdf-viewer/PdfViewer';
import { YamlModal } from '../../components/yaml-editor/YamlEditorModal';
import { TpUserInfo } from '../../data/interfaces';
import { NavigationBar } from '../../features/navigation-bar/NavigationBar';
import { TaskForm } from '../../features/tasks/TaskForm';

const EULA_VERSION = import.meta.env.VITE_EULA_VERSION;

export default function PlatformAppClient({ email, acceptedEulaVersion }: TpUserInfo) {
  return (
    <>
      <AutoFormModal />
      <TaskForm />
      <ConfirmBox />
      <YamlModal />

      <PdfViewer />
      <DataTableModal />

      <ErrorMessage />
      <CountDownBox />
      <div
        id="normalAppWrapper"
        style={{ width: '100%', height: '100%', backgroundColor: 'var(--lightgray-background)' }}
      >
        <NavigationBar />
        <div
          id="appClientArea"
          style={{
            position: 'absolute',
            left: '200px',
            top: '60px',
            width: 'calc(100% - 200px)',
            height: 'calc(100% - 60px)',
          }}
        >
          {email && acceptedEulaVersion == EULA_VERSION && <Outlet />}
        </div>
      </div>

      <div id="openedItemRoot" style={{ position: 'absolute', top: 0, left: 0 }}></div>
      <div id="modalPortalRoot" style={{ position: 'absolute', top: 0, left: 0 }}></div>
    </>
  );
}
